import { match } from 'react-router-dom';
import { IDetailParams } from '../../../common/models/common';

export interface IBackgroundProcessesProps {
  match?: match<IDetailParams>;
}

// Job types the backend can stop part-way; cancel is rejected (409) for any other type.
export const CANCELLABLE_JOB_TYPES: string[] = [
  'SPS Call All Api',
  'Run SPS Scheduler',
  'Export To Excel',
  'Bulk Import',
  'Bulk Update From Excel',
];
